import { Claims, randomInt } from 'its-pages';
import { useSelector } from 'react-redux/es/exports';
import { ROLES } from '../constants/roles';
import { State } from '../redux/state';
import { ITSUser } from '../types/user';
import { MersenneTwister } from '../../../its-pages/src/utils/mersenne-twister';

/* eslint-disable @typescript-eslint/no-empty-function */
export const noop = () => {};

export type TimeoutType = ReturnType<typeof setTimeout> | undefined;

export function randomElement<T>(a: T[], seed?: number): T {
  const rand = new MersenneTwister(seed);
  return a[Math.floor(a.length * rand.random())];
}

export function randomString(length: number): string {
  const possible = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';

  function pickRandom() {
    return possible[randomInt(0, possible.length)];
  }

  const array = [...Array(length)];
  const randomString = array.map(pickRandom).join('');

  return randomString;
}

export function AreArraysEqual<T>(a:T[], b:T[], cmpfn:(a:T, b:T)=>number):boolean {
  if (a.length !== b.length) return false;

  const aSorted = a.slice().sort(cmpfn);
  return  b.slice().sort(cmpfn).every((v,i)=>!cmpfn(v,aSorted[i]));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function xor(a: any, b: any): boolean {
  return a ? !b : b;
}

export const formControlStyle = {
  gridArea: 'classSelect',
  maxWidth: '40vw'
};

export const hasClassrooms = (user?: ITSUser) => (
  user?.classrooms && Object.keys(user.classrooms).length
);

export const hasTeacherClasses= (user?: ITSUser) => (
  user?.teacherClasses && Object.keys(user.teacherClasses).length
);

export const localURL = new URL(window?.location?.href);

export const getRoleFromClaims = (claims?: Claims)=>{
  return claims ? claims.role : ROLES.NONE;
}
export const useRole = ()=>{
  const role = useSelector((state:State)=>{return getRoleFromClaims(state.firebase.authUser?.claims)});
  const override = useSelector((state:State)=>state.firebase.studentRoleOverride);
  if (role === ROLES.TEACHER && override) {
      return ROLES.STUDENT;
  }

  return role;
}

export const useBaseRole = ()=>{
  const role = useSelector((state:State)=>{return getRoleFromClaims(state.firebase.authUser?.claims)});
  return role ? role : ROLES.NONE;
}

export const useClassrooms = ()=>{
  const classrooms = useSelector((state:State)=>state.firebase.currentUser?.classrooms);

  return classrooms;
}

export const useTeacherClasses = ()=>{
  const teacherClasses = useSelector((state:State)=>state.firebase.currentUser?.teacherClasses);

  return teacherClasses;
}